module.exports = __webpack_public_path__ + "images/57c89270f29ecb2de0dd7670cc2a0b4d.png";